var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPlates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#25282F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,25.7L19.4,25.7c0.9,2.3,5.6,1,7.6-2s8-4.1,8-7.7s-12-4.6-16.1-3.9c-4.2,0.8-2.8,3.4-1.2,6.5 C19.4,21.6,18.6,23.4,19.4,25.7z M22.6,14.6c1.3,0,2.4,0.7,2.4,1.5c0,0.9-1.1,1.5-2.4,1.5s-2.4-0.7-2.4-1.5 C20.3,15.3,21.3,14.6,22.6,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.9,17.5L35.9,17.5c-0.3-0.2-0.7,0.1-0.7,0.5c0,1.1-0.1,2.1-0.1,2.3c0,3.6-6,4.7-8,7.7s-7.5,3.8-8.3,1.5 c-0.6-1.5-1.3-4.4-1.8-6.8c-2.2,0.8-3.1,3.5-3.1,3.5l-1.7-0.7c0,0,1.4-3.5,4.4-4.7c-0.1-0.4-0.2-0.7-0.2-0.9 c-0.2-0.6-0.3-1.5-0.4-2.4c0-0.4-0.4-0.6-0.7-0.5c-4.8,2.1-7.9,5.6-7.9,9.6c0,6.4,8,11.5,17.8,11.5S42.8,33,42.8,26.6 C42.8,22.9,40.1,19.6,35.9,17.5z M37,30L37,30c-2.5,3.3-8.8,4.4-8.8,4.4l-0.3-0.8c0,0,3.3-0.4,6.4-3c2.7-2.3,1.5-4.7,1.5-4.7 l2.1-1.4C37.9,24.7,39.2,27.1,37,30z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlates);
export default __webpack_public_path__ + "static/media/icon-plates.b841459e632e18e370f2e07d104464e3.svg";
export { ForwardRef as ReactComponent };